<template>
    <div class="row">
        <div class="col-xs-12">
            <table class="table" id="eligibility-list-table" v-show="hasResults">
                <thead>
                    <th>Bill name</th>
                    <th>Meter Number</th>
                    <th>Actions</th>
                </thead>
                <tbody>
                    <tr v-for="(billAccount, index) in billAccountList"
                        :key="billAccount.id"
                    >
                        <td class="text-center">{{ billAccount.bill_name }}</td>
                        <td class="text-center">{{ billAccount.meter_number }}</td>
                        <td class="text-center">
                            <a class="inputbutton2" :class="{ 'disabled': isDisabled}" @click.prevent="handleProjectCreation(billAccount)">Create Project</a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import axios from 'axios';

export default {
    props: [
        'billAccountList',
    ],
    data() {
        return {
            isDisabled: false,
        }
    },
    computed: {
        hasResults() {
            return (this.billAccountList) ? this.billAccountList.length > 0 : false;
        },
        queryParamProgramTrackId() {

            var programTrackId = null;
            var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
                if(key === 'program_track_id') {
                    programTrackId = value;
                }
            });

            return parseInt(programTrackId);
        },
        queryParamProgramYearId() {

            var programYearId = null;
            var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
                if(key === 'program_year_id') {
                    programYearId = value;
                }
            });

            return parseInt(programYearId);
        },
    },
    methods: {
        handleProjectCreation(billAccount) {

            if(!this.queryParamProgramTrackId) {
                window.notify.message('You must specify a program track to create this project to create a project.', 'error');
                return;
            }
            this.isDisabled = true;

            var request = {
                bill_account_id: billAccount.id,
                program_track_id: this.queryParamProgramTrackId,
                program_year_id: this.queryParamProgramYearId,
            };

            axios.post('/api/projects/create', request).then((res) => {
                this.isDisabled = false;
                if(res.data.active_url) {
                   window.location.replace(res.data.active_url);
                }
            }).catch((error) => {
                window.notify.apiError(error);
            });
        }
    }
}
</script>
<style>
#eligibility-list-table {
    width: 100%;
    margin-bottom: 1rem;
    background-color: transparent;
}

#eligibility-list-table th {
    padding-bottom: 0.25rem;
    border-bottom: 1px solid;
}

#eligibility-list-table td {
    padding: 0.75rem;
    vertical-align: top;
}
</style>

